import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    userInfo:{},
    error:'',
    status:'idle',
    updateUserInfoState:{}
};

export const fetchUserInfo = createAsyncThunk('verify-info/fetchUserInfo', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/getLastReportPersonalInfo',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});

export const updateUserInfo = createAsyncThunk('verify-info/updateUserInfo', async (initialPost) => {
    let accessToken = localStorage.getItem('accessToken');
    let fromData = new FormData();
    fromData.append("id",initialPost.id);
    fromData.append("first_name",initialPost.first_name);
    fromData.append("last_name",initialPost.last_name);
    fromData.append("email",initialPost.email);
    fromData.append("phone",initialPost.phone);
    fromData.append("address",initialPost.address);
    fromData.append("address2",initialPost.address2);
    fromData.append("country",initialPost.country);
    fromData.append("state",initialPost.state);
    fromData.append("is_confirmed",initialPost.terms);
    fromData.append("zip",initialPost.zip);
    fromData.append("dob",initialPost.dob);
    fromData.append("Token",accessToken);
    let response = await axios.post('form/updateLastReportPersonalInfo',fromData);
    if (response.status == 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
})

const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}

const VerifyInfoSlice = createSlice({
    name:'verify-info',
    initialState,
    reducers:{
        blankAddUserInfo:(state)=>{
            state.updateUserInfoState = {};
            state.userInfo = {};
            state.status='idle';
            state.error = ""
        }
    },
    extraReducers:(builder) => {
        builder.addCase(fetchUserInfo.pending, (state)=>{
            state.status = 'loading';
            state.updateUserInfoState = {};
            state.userInfo = {};
        })
        builder.addCase(fetchUserInfo.fulfilled,(state,action)=>{
            state.status = 'succeeded';
            state.userInfo = action.payload;
            state.updateUserInfoState = {};
            state.error = '';
        })
        builder.addCase(fetchUserInfo.rejected,(state,action)=>{
            state.status = 'failed';
            state.updateUserInfoState = {};
            state.userInfo = {};
            state.error = action.error.message;
        })
        builder.addCase(updateUserInfo.pending,(state,action)=>{
            state.status = 'loading';
        })

        builder.addCase(updateUserInfo.fulfilled,(state,action)=>{
            // state.contacts.push(action.payload)
            // state.status="idle";
            state.updateUserInfoState = action.payload
        })
    }
});

export const {blankAddUserInfo} = VerifyInfoSlice.actions;

export default VerifyInfoSlice.reducer;
